import { useEffect, useState } from 'react';
import { ROUTES } from '../constants';
import { getHubRoute } from '../handlers';
import { isRouteFlagEnabled, subscribeToggles } from './index';

// Menu items only shown while their own per-route smartNav flag is ON
// (<DOMAIN>.FALLBACK-ACTIVE.<NORMALIZED_PATH>). Any other item passes through untouched.
const getRouteFlagGatedPaths = (): string[] => [
  getHubRoute(ROUTES.HUB.COMPANY.MEETING_ROOM_MANAGE),
  getHubRoute(ROUTES.HUB.COMPANY.MEETING_ROOM_RESERVED),
  getHubRoute(ROUTES.HUB.COMPANY.MEETING_ROOM_REQUESTS),
];

type MenuItemWithPath = { path?: string };

export function useRouteFlagMenuFilter(): <T extends MenuItemWithPath>(items: T[]) => T[] {
  // React 17 has no useSyncExternalStore: bump a counter on every toggle change to re-render.
  const [, setTogglesVersion] = useState(0);

  useEffect(() => subscribeToggles(() => setTogglesVersion((version) => version + 1)), []);

  return (items) => {
    const gatedPaths = getRouteFlagGatedPaths();
    return items.filter(
      (item) => !item.path || !gatedPaths.includes(item.path) || isRouteFlagEnabled(item.path)
    );
  };
}
